// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { Accordion } from 'Components/frameworks/accordion/Accordion.jsx';
import { Tabs } from 'Components/frameworks/tabs/Tabs.jsx';

type Props = {
  areAllCollapsable?: boolean,
  areMultiExpandable?: boolean,
  initialSelectedItems?: Array<number>,
};

export function ResponsiveTabs(props: Props) {
  const { areAllCollapsable, areMultiExpandable, initialSelectedItems = [], ...rest } = props;

  const { isTablet } = useContext(ResponsiveContext);

  return isTablet ? (
    <Tabs {...rest} initialSelectedItem={initialSelectedItems[0]} />
  ) : (
    <Accordion
      {...rest}
      areAllCollapsable={areAllCollapsable}
      areMultiExpandable={areMultiExpandable}
      initialSelectedItems={initialSelectedItems}
    />
  );
}
